import React from 'react';
import IMMasterTable from '../../components/ui/IMMasterTable';
import {
    Row,
    Card,
    CardBody,
   
  } from "reactstrap";

const Services = () => {
  return (
    <div className="page-content">
      <Card>
        <CardBody>
          <div>
            <Row>
              <IMMasterTable collectionName="services" />
            </Row>
          </div>
        </CardBody>
      </Card>
    </div>
  )
};

export default  Services;